

import React, { useEffect, useState } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import {
  getBrandServ,
  addBrandServ,
  deleteBrandServ,
  updateBrandServ,
} from "../../services/brand.services";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import NoRecordFound from "../../Components/NoRecordFound";

import { IMAGE_BASE_URL } from "../../utils/api_base_url_configration";
// import "../../styles/listPages.css";

const STAT_ICONS = ["🏷️", "✅", "⏸️"];

function BrandsList() {

    const getImageUrl = (image) => {
    if (!image) return "";
    if (image.startsWith("http")) return image;
    return `${IMAGE_BASE_URL}${image}`;
  };

  const getPreviewImage = (img) => {
    if (!img) return "";
    if (img.startsWith("blob:")) return img;
    return getImageUrl(img);
  };

  const [list, setList] = useState([]);
  const [statics, setStatics] = useState(null);

  const [payload, setPayload] = useState({
    searchKey: "",
    status: "",
    pageNo: 1,
    pageCount: 10,
    sortByField: "",
  });

  const [showSkelton, setShowSkelton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [totalPages, setTotalPages] = useState(1);

  const [addFormData, setAddFormData] = useState({
    name: "",
    image: "",
    status: "",
    show: false,
    imgPrev: "",
  });

  const [editFormData, setEditFormData] = useState({
    name: "",
    image: "",
    status: "",
    _id: "",
    imgPrev: "",
  });

  /* ─────────────────────────────────────────────
      GET BRANDS
  ───────────────────────────────────────────── */

  const handleGetBrandFunc = async () => {
    if (list.length === 0) {
      setShowSkelton(true);
    }

    try {
      const response = await getBrandServ(payload);

      setList(response?.data?.data || []);
      setStatics(response?.data?.documentCount);
    } catch (error) {}

    setShowSkelton(false);
  };

  useEffect(() => {
    handleGetBrandFunc();
  }, [payload]);

  useEffect(() => {
    if (statics?.totalCount && payload.pageCount) {
      setTotalPages(
        Math.ceil(statics.totalCount / payload.pageCount)
      );
    }
  }, [statics, payload.pageCount]);

  /* ─────────────────────────────────────────────
      ADD BRAND
  ───────────────────────────────────────────── */

  const handleAddBrandFunc = async () => {
    setIsLoading(true);

    const formData = new FormData();

    formData.append("name", addFormData?.name);
    formData.append("image", addFormData?.image);
    formData.append("status", addFormData?.status);

    try {
      const response = await addBrandServ(formData);

      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);

        setAddFormData({
          name: "",
          image: "",
          status: "",
          show: false,
          imgPrev: "",
        });

        handleGetBrandFunc();
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Internal Server Error"
      );
    }

    setIsLoading(false);
  };

  /* ─────────────────────────────────────────────
      DELETE BRAND
  ───────────────────────────────────────────── */

  const handleDeleteBrandFunc = async (id) => {
    const confirmed = window.confirm(
      "Delete this brand?"
    );

    if (!confirmed) return;

    try {
      const response = await deleteBrandServ(id);

      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);

        handleGetBrandFunc();
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Internal Server Error"
      );
    }
  };

  /* ─────────────────────────────────────────────
      UPDATE BRAND
  ───────────────────────────────────────────── */

  const handleUpdateBrandFunc = async () => {
    setIsLoading(true);

    const formData = new FormData();

    if (editFormData?.image) {
      formData.append("image", editFormData?.image);
    }

    formData.append("name", editFormData?.name);
    formData.append("status", editFormData?.status);
    formData.append("_id", editFormData?._id);

    try {
      const response = await updateBrandServ(formData);

      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);

        setEditFormData({
          name: "",
          image: "",
          status: "",
          _id: "",
          imgPrev: "",
        });

        handleGetBrandFunc();
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Internal Server Error"
      );
    }

    setIsLoading(false);
  };

  /* ─────────────────────────────────────────────
      PAGINATION
  ───────────────────────────────────────────── */

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPayload({
        ...payload,
        pageNo: newPage,
      });
    }
  };

  /* ─────────────────────────────────────────────
      STATS
  ───────────────────────────────────────────── */

  const staticsArr = [
    {
      title: "Total Brands",
      count: statics?.totalCount,
      icon: STAT_ICONS[0],
    },
    {
      title: "Active Brands",
      count: statics?.activeCount,
      icon: STAT_ICONS[1],
    },
    {
      title: "Inactive Brands",
      count: statics?.inactiveCount,
      icon: STAT_ICONS[2],
    },
  ];

  return (
    <div className="bodyContainer">
      <Sidebar
        selectedMenu="Product Management"
        selectedItem="Brands"
      />

      <div className="mainContainer">
        <TopNav
          pageTitle="Brands"
          pagePath="Home / Product Management / Brands"
        />

        <div className="pl-root">

          {/* ─────────────────────────
                STATS
          ───────────────────────── */}

          <div className="pl-stat-grid">
            {staticsArr.map((v, i) => (
              <div className="pl-stat-card" key={i}>
                <div className="pl-stat-icon">
                  {v.icon}
                </div>

                <div>
                  <div className="pl-stat-val">
                    {v.count ?? "—"}
                  </div>

                  <div className="pl-stat-lbl">
                    {v.title}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* ─────────────────────────
                TOOLBAR
          ───────────────────────── */}

          <div className="pl-toolbar">

            <div className="pl-toolbar-title">
              Brands
            </div>

            <input
              className="pl-input"
              placeholder="🔍 Search brands..."
              onChange={(e) =>
                setPayload({
                  ...payload,
                  searchKey: e.target.value,
                })
              }
            />

            <select
              className="pl-select"
              onChange={(e) =>
                setPayload({
                  ...payload,
                  status: e.target.value,
                })
              }
            >
              <option value="">All Status</option>
              <option value={true}>Active</option>
              <option value={false}>Inactive</option>
            </select>

            <button
              className="pl-btn pl-btn-red"
              onClick={() =>
                setAddFormData({
                  ...addFormData,
                  show: true,
                })
              }
            >
              <i className="ti ti-plus" />
              Add Brand
            </button>
          </div>

          {/* ─────────────────────────
                TABLE
          ───────────────────────── */}

          <div className="pl-table-wrap">

            <div className="pl-table-scroll">

              <table className="pl-table">

                <thead>
                  <tr>
                    <th>#</th>
                    <th>Brand</th>
                    <th className="center">Status</th>
                    <th className="center">
                      Created
                    </th>
                    <th className="center">
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody>

                  {showSkelton ? (
                    [...Array(10)].map((_, i) => (
                      <tr key={i}>
                        {[...Array(5)].map((__, j) => (
                          <td
                            key={j}
                            className="pl-skel-cell"
                          >
                            <Skeleton height={20} />
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : list?.length === 0 ? (
                    <tr>
                      <td
                        colSpan="5"
                        style={{
                          textAlign: "center",
                          padding: "50px",
                        }}
                      >
                        <NoRecordFound />
                      </td>
                    </tr>
                  ) : (
                    list?.map((v, i) => (
                      <tr key={v?._id}>

                        {/* SR */}

                        <td>
                          <span className="pl-sr">
                            {(payload.pageNo - 1) *
                              payload.pageCount +
                              i +
                              1}
                          </span>
                        </td>

                        {/* BRAND */}

                        <td>
                          <div className="pl-prod-cell">

                            <img
                              src={getImageUrl(v?.image)}
                              alt="brand"
                              className="pl-prod-img"
                            />

                            <div className="pl-prod-name">
                              {v?.name}
                            </div>
                          </div>
                        </td>

                        {/* STATUS */}

                        <td className="center">
                          {v?.status ? (
                            <span className="pl-badge active">
                              <i
                                className="ti ti-circle-check"
                                style={{
                                  fontSize: 13,
                                }}
                              />
                              Active
                            </span>
                          ) : (
                            <span className="pl-badge inactive">
                              <i
                                className="ti ti-circle-x"
                                style={{
                                  fontSize: 13,
                                }}
                              />
                              Inactive
                            </span>
                          )}
                        </td>

                        {/* DATE */}

                        <td className="center">
                          {moment(
                            v?.createdAt
                          ).format("DD MMM YYYY")}
                        </td>

                        {/* ACTION */}

                        <td className="center">

                          <button
                            className="pl-view-btn me-2"
                            onClick={() =>
                              setEditFormData({
                                name: v?.name,
                                image: "",
                                imgPrev: v?.image,
                                status: v?.status,
                                _id: v?._id,
                              })
                            }
                          >
                            <i className="ti ti-edit" />
                            Edit
                          </button>

                          <button
                            className="pl-btn pl-btn-danger"
                            style={{ height: "34px" }}
                            onClick={() =>
                              handleDeleteBrandFunc(
                                v?._id
                              )
                            }
                          >
                            <i className="ti ti-trash" />
                            Delete
                          </button>

                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* ─────────────────────────
                  PAGINATION
            ───────────────────────── */}

            <div className="pl-pagination">

              <div className="pl-show-row">
                Show

                <select
                  className="pl-select"
                  style={{
                    height: "34px",
                    padding: "0 10px",
                    minWidth: "unset",
                  }}
                  value={payload.pageCount}
                  onChange={(e) =>
                    setPayload({
                      ...payload,
                      pageCount: parseInt(
                        e.target.value
                      ),
                      pageNo: 1,
                    })
                  }
                >
                  {[10, 25, 50, 100].map((v) => (
                    <option key={v} value={v}>
                      {v}
                    </option>
                  ))}
                </select>

                entries
              </div>

              <div className="pl-page-btns">

                <button
                  className="pl-pg-btn"
                  disabled={payload.pageNo === 1}
                  onClick={() =>
                    handlePageChange(
                      payload.pageNo - 1
                    )
                  }
                >
                  <i className="ti ti-chevron-left" />
                </button>

                {[...Array(totalPages)].map((_, i) => {
                  const page = i + 1;

                  if (
                    page === 1 ||
                    page === totalPages ||
                    (page >= payload.pageNo - 1 &&
                      page <= payload.pageNo + 1)
                  ) {
                    return (
                      <button
                        key={page}
                        className={`pl-pg-btn ${
                          payload.pageNo === page
                            ? "active"
                            : ""
                        }`}
                        onClick={() =>
                          handlePageChange(page)
                        }
                      >
                        {page}
                      </button>
                    );
                  }

                  return null;
                })}

                <button
                  className="pl-pg-btn"
                  disabled={
                    payload.pageNo === totalPages
                  }
                  onClick={() =>
                    handlePageChange(
                      payload.pageNo + 1
                    )
                  }
                >
                  <i className="ti ti-chevron-right" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ─────────────────────────────
            ADD MODAL
      ───────────────────────────── */}

      {addFormData?.show && (
        <div
          className="pl-modal-overlay"
          onClick={() =>
            setAddFormData({
              name: "",
              image: "",
              status: "",
              show: false,
              imgPrev: "",
            })
          }
        >
          <div
            className="pl-modal"
            onClick={(e) => e.stopPropagation()}
          >

            <div className="pl-modal-header">

              <div className="pl-modal-title">
                Add Brand
              </div>

              <button
                className="pl-modal-close"
                onClick={() =>
                  setAddFormData({
                    name: "",
                    image: "",
                    status: "",
                    show: false,
                    imgPrev: "",
                  })
                }
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <div className="pl-modal-body">

                    <img
  src={getPreviewImage(addFormData?.imgPrev) || "https://placehold.co/600x400?text=Preview"}
  alt=""
  className="pl-preview-img"
/>

              <label className="pl-field-label">
                Upload Image
              </label>

              <input
                className="pl-field-input"
                type="file"
                style={{
                  height: "auto",
                  padding: "10px 14px",
                }}
                onChange={(e) =>
                  setAddFormData({
                    ...addFormData,
                    image: e.target.files[0],
                    imgPrev: URL.createObjectURL(
                      e.target.files[0]
                    ),
                  })
                }
              />

              <label className="pl-field-label">
                Brand Name
              </label>

              <input
                className="pl-field-input"
                type="text"
                placeholder="Enter brand name"
                onChange={(e) =>
                  setAddFormData({
                    ...addFormData,
                    name: e.target.value,
                  })
                }
              />

              <label className="pl-field-label">
                Status
              </label>

              <select
                className="pl-field-input"
                value={addFormData?.status}
                onChange={(e) =>
                  setAddFormData({
                    ...addFormData,
                    status: e.target.value,
                  })
                }
              >
                <option value="">
                  Select Status
                </option>

                <option value={true}>
                  Active
                </option>

                <option value={false}>
                  Inactive
                </option>
              </select>
            </div>

            <div className="pl-modal-footer">

              <button
                className="pl-btn"
                style={{
                  background: "#f0eded",
                  color: "#555",
                }}
                onClick={() =>
                  setAddFormData({
                    name: "",
                    image: "",
                    status: "",
                    show: false,
                    imgPrev: "",
                  })
                }
              >
                Cancel
              </button>

              <button
                className="pl-btn pl-btn-red"
                disabled={
                  !addFormData?.name ||
                  !addFormData?.image ||
                  !addFormData?.status ||
                  isLoading
                }
                style={{
                  opacity:
                    !addFormData?.name ||
                    !addFormData?.image ||
                    !addFormData?.status
                      ? 0.5
                      : 1,
                }}
                onClick={
                  !isLoading
                    ? handleAddBrandFunc
                    : undefined
                }
              >
                {isLoading
                  ? "Saving..."
                  : "Add Brand"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ─────────────────────────────
            EDIT MODAL
      ───────────────────────────── */}

      {editFormData?._id && (
        <div
          className="pl-modal-overlay"
          onClick={() =>
            setEditFormData({
              name: "",
              image: "",
              status: "",
              _id: "",
              imgPrev: "",
            })
          }
        >
          <div
            className="pl-modal"
            onClick={(e) => e.stopPropagation()}
          >

            <div className="pl-modal-header">

              <div className="pl-modal-title">
                Update Brand
              </div>

              <button
                className="pl-modal-close"
                onClick={() =>
                  setEditFormData({
                    name: "",
                    image: "",
                    status: "",
                    _id: "",
                    imgPrev: "",
                  })
                }
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <div className="pl-modal-body">
     <img
  src={getPreviewImage(editFormData?.imgPrev)}
  alt=""
  className="pl-preview-img"
/>

              <label className="pl-field-label">
                Upload Image
              </label>

              <input
                className="pl-field-input"
                type="file"
                style={{
                  height: "auto",
                  padding: "10px 14px",
                }}
                onChange={(e) =>
                  setEditFormData({
                    ...editFormData,
                    image: e.target.files[0],
                    imgPrev: URL.createObjectURL(
                      e.target.files[0]
                    ),
                  })
                }
              />

              <label className="pl-field-label">
                Brand Name
              </label>

              <input
                className="pl-field-input"
                type="text"
                value={editFormData?.name}
                onChange={(e) =>
                  setEditFormData({
                    ...editFormData,
                    name: e.target.value,
                  })
                }
              />

              <label className="pl-field-label">
                Status
              </label>

              <select
                className="pl-field-input"
                value={editFormData?.status}
                onChange={(e) =>
                  setEditFormData({
                    ...editFormData,
                    status: e.target.value,
                  })
                }
              >
                <option value="">
                  Select Status
                </option>

                <option value={true}>
                  Active
                </option>

                <option value={false}>
                  Inactive
                </option>
              </select>
            </div>

            <div className="pl-modal-footer">

              <button
                className="pl-btn"
                style={{
                  background: "#f0eded",
                  color: "#555",
                }}
                onClick={() =>
                  setEditFormData({
                    name: "",
                    image: "",
                    status: "",
                    _id: "",
                    imgPrev: "",
                  })
                }
              >
                Cancel
              </button>

              <button
                className="pl-btn pl-btn-red"
                disabled={
                  !editFormData?.name ||
                  !editFormData?.status ||
                  isLoading
                }
                style={{
                  opacity:
                    !editFormData?.name ||
                    !editFormData?.status
                      ? 0.5
                      : 1,
                }}
                onClick={
                  !isLoading
                    ? handleUpdateBrandFunc
                    : undefined
                }
              >
                {isLoading
                  ? "Saving..."
                  : "Update Brand"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BrandsList;